import { useFormContext } from '../../AddSessionForm.types';
import { UserInfoExisting } from './UserInfoExisting.component';
import { UserInfoInvite } from './UserInfoInvite.component';


export const UserInfo: React.FC = () => {
  const formikContext = useFormContext();
  const isInvite = formikContext.values.isNewPatient;

  if (isInvite) {
    return <UserInfoInvite />;
  }

  return <UserInfoExisting />;
};
